module.exports = __webpack_public_path__ + "fonts/Lexend-600-latin-ext17.12601d9.woff2";